import { CalendarDays, Laptop, Receipt, FileText } from "lucide-react";
import styles from "./quick-actions.module.css";
import { Link } from "react-router-dom";
import { useSqeLabs } from "../../../../../hooks/use-sqe-labs.ts";

const actions = [
  {
    label: "View Attendance",
    subtitle: "Weekly logs & history",
    icon: CalendarDays,
    path: "/dashboard/myAttendance",
  },
  {
    label: "Request Leave",
    subtitle: "Plan time off",
    icon: FileText,
    path: "/dashboard/leaveApply",
  },
  {
    label: "Asset Request",
    subtitle: "Hardware & software",
    icon: Laptop,
    path: "/dashboard/assetRequest",
  },
  {
    label: "Reimbursements",
    subtitle: "Expense claims",
    icon: Receipt,
    path: "/dashboard/reimbursementRequest",
  },
];

export function QuickActions() {
  const isSqeLabs = useSqeLabs();
  return (
    <div className={styles.actionGrid}>
     {actions
  .filter(
    (action) =>
      !(
        isSqeLabs &&
        action.label === "Reimbursements"
      )
  )
  .map((action) => {
        const Icon = action.icon;
        return (
          <Link
            key={action.label}
            to={action.path}
            className={`d-flex gap-3 p-3 ${styles.actionCard}`}
          >
            <div
              className={`d-flex align-items-center justify-content-center ${styles.iconBg}`}
            >
              <Icon className="icon-accent" size={18} />
            </div>

            <div className="d-flex flex-column align-items-start text-start">
              <p className="heading-xs mb-0">{action.label}</p>
              <p className="sub-heading-xs mb-0">{action.subtitle}</p>
            </div>
          </Link>
        );
      })}
    </div>
  );
}
